// import { WSIBClassList } from "components/WSIBClass";

import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";
import { WSIBCodeList } from "../../components/WSIBCodeList";

export interface IWSIBCodeListPage { }

export const WSIBCodeListPage: FC<IWSIBCodeListPage> = (
  props: IWSIBCodeListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Category List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<WSIBCodeList />}
    />
  );
};
